import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as conveniosApi from '../api/convenios'
import { useSelector } from 'react-redux'

const Convenios = () => {
  const translations = useSelector(state => state.translations.translations)

  const columns = [
    {
      title: "Imagem",
      field: '_id',
      filtering: false,
      sorting: false,
      cellStyle: {
        maxWidth: 66,
      },
      render: rowData =>
        <img
          className="noticia-img"
          src={conveniosApi.getFileConvenios(rowData._id)}
          alt="" />
    },
    {
      title: "Nome",
      field: "name",
      sorting: true
    },
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Convenios"} subtitle={"Lista de convenios"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'convenios'}
            columns={columns}
            fetchFunction={conveniosApi.fetchItems}
            removeFunction={conveniosApi.removeItem}
            statusFunction={conveniosApi.statusItem}
            enableSearch
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Convenios
